<template>
  <v-text-field
    :id="fieldId"
    density="comfortable"
    variant="solo"
    flat
    persistent-placeholder
    validate-on="blur"
    :label="label"
    :prepend-icon="icon"
    :type="type"
    :autocomplete="autocomplete"
    :rules="rules"
    :readonly="readonly ? readonly : false"
  />
</template>

<script lang="ts" src="./PolteqTextField.ts"></script>
